import baseAPI from '@/api/base';
import {
  EditPhotoUnderline,
  GetPhotoUnderline,
  RegisterPhotoUnderline,
} from '@/dtos/photo_underline.dto';
import {
  DELETE_PHOTO_UNDERLINE_URL,
  EDIT_PHOTO_UNDERLINE_URL,
  GET_PHOTO_UNDERLINE_URL,
  REGISTER_PHOTO_UNDERLINE_URL,
  TOGGLE_PHOTO_UNDERLINE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class PhotoUnderline {
  static getPhotoUnderlines = async (
    getPhotoUnderline: GetPhotoUnderline
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PHOTO_UNDERLINE_URL, {
      params: getPhotoUnderline,
    });
    console.log('response', response);
    return response;
  };

  static registerPhotoUnderline = async (
    registerPhotoUnderline: RegisterPhotoUnderline
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_PHOTO_UNDERLINE_URL,
      registerPhotoUnderline
    );
    console.log('response', response);
    return response;
  };

  static editPhotoUnderline = async (
    editPhotoUnderline: EditPhotoUnderline
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_PHOTO_UNDERLINE_URL,
      editPhotoUnderline
    );
    return response;
  };

  static togglePhotoUnderlineIsActive = async (
    editPhotoUnderline: EditPhotoUnderline
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PHOTO_UNDERLINE_IS_ACTIVE_URL,
      {
        ...editPhotoUnderline,
      }
    );
    return response;
  };

  static deletePhotoUnderline = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PHOTO_UNDERLINE_URL}/${id}`
    );
    return response;
  };
}

export default PhotoUnderline;

